import type { RelicDefinition } from '../core/types';

export const relicDefinitions: RelicDefinition[] = [
  {
    id: 'smiths_mark',
    name: "Mechanic's Seal",
    description: 'The first Gear played each combat loses no Durability.',
    rarity: 'starter',
    modifiers: { gearProtectionPerCombat: 1 },
  },
  {
    id: 'riveted_apron',
    name: "Riveted Containment Apron",
    description: 'Start each combat with 7 Block.',
    rarity: 'common',
    modifiers: { startBlock: 7 },
  },
  {
    id: 'cold_chisel',
    name: "Extraction Chisel",
    description: 'Attacks deal 1 additional damage per hit.',
    rarity: 'common',
    modifiers: { attackBonus: 1 },
  },
  {
    id: 'quenching_oil',
    name: "Closed-Loop Coolant",
    description: 'Overheat deals 1 less damage.',
    rarity: 'common',
    modifiers: { overheatDamageBonus: -1 },
  },
  {
    id: 'salvagers_ledger',
    name: "Maintenance Ledger",
    description: 'Whenever Gear Breaks, gain 8 Block.',
    rarity: 'common',
    modifiers: { blockOnGearBreak: 8 },
  },
  {
    id: 'spare_bellows',
    name: "Primer Pump",
    description: 'Start each combat with 1 Heat.',
    rarity: 'common',
    modifiers: { startHeat: 1 },
  },
  {
    id: 'barbed_plate',
    name: "Anchor-Spike Plate",
    description: 'Start each combat with 2 Thorns.',
    rarity: 'common',
    modifiers: { startThorns: 2 },
  },
  {
    id: 'miners_lamp',
    name: "Survey Lamp",
    description: 'Draw 2 additional cards on the first turn of combat.',
    rarity: 'common',
    modifiers: { openingDraw: 2 },
  },
  {
    id: 'ember_locket',
    name: "Field Dressing Case",
    description: 'Heal 2 HP after each combat.',
    rarity: 'common',
    modifiers: { healAfterCombat: 2 },
  },
  {
    id: 'brass_knuckles',
    name: "Reinforced Grip",
    description: 'Gain 1 Strength at the start of combat.',
    rarity: 'common',
    modifiers: { startStrength: 1 },
  },
  {
    id: 'foremans_whistle',
    name: "Lockdown Whistle",
    description: 'Start combat with 1 Strength and 1 Vulnerable.',
    rarity: 'elite',
    modifiers: { startStrength: 1, startVulnerable: 1 },
  },
  {
    id: 'broken_crown',
    name: "Braced Collar",
    description: 'Cards grant 2 additional Block whenever they grant Block.',
    rarity: 'elite',
    modifiers: { blockBonus: 2 },
  },
  {
    id: 'slagglass_eye',
    name: "Calibration Lens",
    description: 'Attacks deal 2 additional damage per hit.',
    rarity: 'elite',
    modifiers: { attackBonus: 2 },
  },
  {
    id: 'overclocked_core',
    name: "Overdriven Refiner",
    description: 'Gain 1 Energy each turn. Overheat deals 2 additional damage.',
    rarity: 'boss',
    modifiers: { maxEnergy: 1, overheatDamageBonus: 2 },
  },
  {
    id: 'bottomless_satchel',
    name: "Overslung Tool Roll",
    description: 'Draw 1 additional card each turn, but lose 1 Energy each turn.',
    rarity: 'boss',
    modifiers: { drawPerTurn: 1, maxEnergy: -1 },
  },
  {
    id: 'hollow_ingot',
    name: "Counterweight Insert",
    description: 'The first 3 Gear plays each combat lose no Durability. Lose 8 Max HP when taken.',
    rarity: 'boss',
    modifiers: { gearProtectionPerCombat: 2, maxHp: -8 },
  },
  {
    id: 'white_crucible',
    name: "Insulated Reservoir",
    description: 'Start each combat at 3 Heat. Overheat deals 2 less damage.',
    rarity: 'boss',
    modifiers: { startHeat: 3, overheatDamageBonus: -2 },
  },
  {
    id: 'menders_anvil',
    name: "Portable Repair Die",
    description: 'Start combat with 4 Block. Repair 1 Durability after every combat.',
    rarity: 'boss',
    modifiers: { startBlock: 4, repairAfterCombat: 1 },
  },
  {
    id: 'debt_engine',
    name: "Borrowed Reflex Frame",
    description: 'Draw 3 additional cards on turn one. Lose 12 Max HP when taken.',
    rarity: 'boss',
    modifiers: { openingDraw: 3, maxHp: -12 },
  },
];
